import { useQuery } from "@tanstack/react-query";
import { getDoctorSlots } from "../../../services/doctors";

import { useToast } from "../../../components/ui/use-toast";
import { useEffect } from "react";

export function useDoctorSlots(
  professionalId: string | undefined,
  branchId: number | undefined,
  enabled = true
) {
  const { toast } = useToast();

  const {
    data: slots,
    isLoading,
    isError,
    isFetched,
  } = useQuery({
    queryKey: ["doctor-slots", professionalId, branchId],
    queryFn: () => getDoctorSlots(professionalId, branchId),
    enabled: enabled && !!professionalId && !!branchId,
  });

  useEffect(() => {
    if (isError) {
      toast({
        title: "Failed to fetch doctor slots",
        variant: "destructive",
      });
    }
  }, [isError, toast]);

  return { slots, isLoading, isFetched };
}
